function getStorage(): Storage | null {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return window.localStorage;
}

// Function to get data from local storage
export function getLocalStorageData(keyName: string) {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  try {
    const savedItem = storage.getItem(keyName);
    // Check if the saved item looks like a JSON object or array before parsing
    if (savedItem && (savedItem.startsWith('{') || savedItem.startsWith('['))) {
      return JSON.parse(savedItem);
    }
    return savedItem;
  } catch (error) {
    console.error(`Error parsing localStorage item '${keyName}':`, error);
    return null;
  }
}

// Function to save data to local storage
export function saveLocalStorageData(keyName: string, value: unknown) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    if (typeof value === 'object' && value !== null) {
      storage.setItem(keyName, JSON.stringify(value));
    } else {
      storage.setItem(keyName, String(value));
    }
  } catch (error) {
    console.error(`Error saving localStorage item '${keyName}':`, error);
  }
}

// Function to delete data from local storage
export function deleteLocalStorageData(keyName: string) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(keyName);
  } catch (error) {
    console.error(`Error removing localStorage item '${keyName}':`, error);
  }
}

// Function to update data in local storage
export function updateLocalStorageData(keyName: string, updateVal: unknown) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    const item = storage.getItem(keyName);
    if (!item) {
      return;
    }

    if (typeof updateVal === 'object' && updateVal !== null) {
      storage.setItem(keyName, JSON.stringify(updateVal));
    } else {
      storage.setItem(keyName, String(updateVal));
    }
  } catch (error) {
    console.error(`Error updating localStorage item '${keyName}':`, error);
  }
}

export function clearLocalStorage() {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
}
